/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Booking_Sync_Cancel_RequestedInputs */

const en_booking_sync_cancel_requested = /** @type {(inputs: Booking_Sync_Cancel_RequestedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Withdrawal asked · ${i?.state}`)
};

/**
* | output |
* | --- |
* | "Withdrawal asked · {state}" |
*
* @param {Booking_Sync_Cancel_RequestedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const booking_sync_cancel_requested = /** @type {((inputs: Booking_Sync_Cancel_RequestedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Sync_Cancel_RequestedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_booking_sync_cancel_requested(inputs)
});